/**
 * Which outline a My Dials tile wears (KEY-520).
 *
 * Six-across tiles are a grid of rings and a caption; nothing on the face says what KIND of dial it is.
 * Two kinds change what the tile means, so they get an outline rather than a badge — a badge costs a line
 * of the caption, which is what made six-across possible in the first place (see {@link DialTile}).
 *
 * Pure and separate from the component because the precedence is a product decision, not styling: where a
 * dial is BOTH a group and out for checking — a group sent for checking, which is the case that prompted
 * this — checking wins. "Anything you type in here is thrown away" outranks "this one contains other
 * dials", and only one outline can be worn at a time.
 */
export interface TileMarker {
  /** CSS colour for the tile's border. */
  colour: string;
  /** CSS border width. Checking is thicker so it reads before the colour does. */
  width: string;
  /** Appended to the tile's title, so the meaning isn't carried by hue alone. */
  note: string;
}

export function tileMarkerFor({ group = false, testing = false, demo = false }: { group?: boolean; testing?: boolean; demo?: boolean }): TileMarker | null {
  if (testing) {
    return {
      colour: "var(--st-overdue)",
      width: "2px",
      note: "Out for checking — anything entered here is discarded.",
    };
  }
  // KEY-938: a demo outranks the group outline for the same reason testing does — which copy this is matters
  // more than what shape it is.
  if (demo) {
    return {
      colour: "var(--st-info, #2563eb)",
      width: "2px",
      note: "Demo dial — files are never stored in it, and everything in it is made up.",
    };
  }
  if (group) {
    return {
      colour: "var(--tile-group)",
      width: "var(--border-w)",
      note: "Group dial — its action points are other dials.",
    };
  }
  return null;
}
